<template>
	<div v-editable="blok">
		<UtilsMaybeWrapped :wrapped="!!blok.url?.cached_url">
			<template #wrapper="{children}">
				<Component
					:is="linkComponent"
					:href="blok.url?.cached_url"
					:target="blok.url?.target"
					tabindex="-1"
				>
					<Component :is="children" />
				</Component>
			</template>
			<template #default>
				<div class="rounded-2.5xl overflow-hidden rem:h-[288px]">
					<NuxtPicture
						v-if="blok.image?.filename"
						provider="storyblok"
						height="434"
						width="550"
						:modifiers="storyblokFocusModifiers(blok.image.focus)"
						:src="blok.image.filename"
						:alt="blok.image.alt || ''"
						sizes="xs:90vw sm:90vw md:375px lg:523px xxl:380px inf:404px"
						:img-attrs="{class:'w-full h-full object-cover block'}"
						loading="lazy"
					/>
				</div>
				<div class="p-4">
					<h3 class="typo-h3 text-heading-primary">
						{{ blok.title }}
					</h3>
					<p v-if="blok.text" class="mt-2">
						{{ blok.text }}
					</p>
					<button
						v-if="blok.ctaButton"
						type="button"
						:aria-label="ctaAriaLabel"
						class="btn btn-tertiary btn-lg md:btn-lg mt-4"
					>
						<NuxtIcon name="custom/arrow-right" class="text-sm" filled />
						{{ blok.ctaButton }}
					</button>
				</div>
			</template>
		</UtilsMaybeWrapped>
	</div>
</template>

<script setup lang="ts">
	import type {CarouselSlideStoryblok} from '@/storyblok/types';

	interface Props {
		blok: CarouselSlideStoryblok;
	}

	const props = defineProps<Props>();

	const linkComponent = computed(() => {
		if (props.blok.url?.linktype === 'story') {
			return resolveComponent('AbsoluteInternalLink');
		}
		return 'a';
	});

	const ctaAriaLabel = computed(() => {
		// Feel free to add more cases here
		switch (props.blok.ctaButton) {
			case 'Zjistit více':
				return `Zjistit více o ${props.blok.title}`;
			default:
				return props.blok.ctaButton || '';
		}
	});
</script>
